@if (!loadingForm()) {
  <div
    class="container full-page ats-custom-scroll po-pl-sm-2 po-pr-sm-2"
    [style.--footer-height]="footerHeight"
  >
    <section class="easy-apply-form" role="form" aria-labelledby="easy-apply-title">
      @if (companyName || jobTitle) {
        <div class="job-summary">
          <div class="job-summary__header">
            <div class="job-summary__logo">
              <img
                [src]="companyLogoUrl"
                [alt]="companyLogoDescription || companyName || ('l-company' | translate)"
              />
            </div>
            <p class="company-name" [atsTruncateText]="1">
              {{ companyName }}
            </p>
          </div>
          <h3 class="job-title" atsTruncateText>
            {{ jobTitle }}
          </h3>
          @if (!loggedUser()) {
            <span data-cy="easy-apply-info-used-only-for-this-application">{{
              'l-job-application-info-used-only-for-this-application' | translate
            }}</span>
          }
        </div>
      }

      <form [formGroup]="formGroup" novalidate>
        <div class="po-row form-grid">
          @if (formGroup.get('fullName'); as control) {
            <div class="po-sm-12 field-mb">
              <p class="required-label">
                {{ 'l-fullname' | translate }}
                <span class="required-indicator" aria-hidden="true">*</span>
              </p>
              <po-input
                formControlName="fullName"
                [p-placeholder]="'l-applicant-name-placeholder' | translate"
                [atsLibFieldAriaLabel]="'l-fullname' | translate"
                [p-required]="true | booleanToString"
                [p-auto-focus]="true"
                data-cy="easy-apply-full-name"
              >
              </po-input>

              @if (control.touched && control.hasError('fullName')) {
                <ats-lib-form-field-message
                  [message]="'l-message-full-name-required' | translate"
                ></ats-lib-form-field-message>
              }
              @if (control.touched && control.hasError('required')) {
                <ats-lib-form-field-message
                  [message]="'l-required' | translate"
                ></ats-lib-form-field-message>
              }
            </div>
          }

          @if (formGroup.get('birthday'); as control) {
            <div class="po-sm-12 field-mb">
              <p class="required-label">
                {{ 'l-birthday' | translate }}
                <span class="required-indicator" aria-hidden="true">*</span>
              </p>
              <ats-lib-datepicker
                formControlName="birthday"
                [p-placeholder]="'l-applicant-birthday-placeholder' | translate"
                [atsLibFieldAriaLabel]="'l-birthday' | translate"
                [p-max-date]="maxDate"
                [p-required]="true | booleanToString"
                data-cy="easy-apply-birthday"
                [p-error-message]="birthdayErrorMessage | translate"
                (focusin)="datepickerErrorMessageHelper.onFocus('birthday')"
                (focusout)="datepickerErrorMessageHelper.onFocusOut('birthday')"
                [p-hide-error-message]="control.dirty && control.hasError('youAreNotOldEnough')"
              ></ats-lib-datepicker>

              @if (control.dirty && control.hasError('youAreNotOldEnough')) {
                <ats-lib-form-field-message
                  [message]="'l-has-no-minimum-age' | translate"
                ></ats-lib-form-field-message>
              }
            </div>
          }

          @if (formGroup.get('email'); as control) {
            <div class="po-sm-12 field-mb">
              <p class="required-label">
                {{ 'l-email' | translate }}
                <span class="required-indicator" aria-hidden="true">*</span>
              </p>
              <po-email
                formControlName="email"
                [p-placeholder]="'l-applicant-email-placeholder' | translate"
                [atsLibFieldAriaLabel]="'l-email' | translate"
                [p-required]="true | booleanToString"
                data-cy="easy-apply-email"
              >
              </po-email>

              @if (control.touched && control.hasError('required')) {
                <ats-lib-form-field-message
                  [message]="'l-required' | translate"
                ></ats-lib-form-field-message>
              }
              @if (control.touched && (control.hasError('pattern') || control.hasError('email'))) {
                <ats-lib-form-field-message
                  [message]="'l-valid-email' | translate"
                ></ats-lib-form-field-message>
              }
            </div>
          }

          @if (formGroup.get('cellphone'); as control) {
            <div class="po-sm-12 field-mb">
              <p class="required-label">
                {{ 'l-cellphone-ddd' | translate }}
                <span class="required-indicator" aria-hidden="true">*</span>
              </p>
              <po-input
                formControlName="cellphone"
                p-mask="(99) 99999?-9999"
                p-mask-format-model="true"
                [p-placeholder]="'l-applicant-cellphone-placeholder' | translate"
                [atsLibFieldAriaLabel]="'l-cellphone-number' | translate"
                [p-required]="true | booleanToString"
                data-cy="easy-apply-cellphone"
              >
              </po-input>

              @if (control.touched && control.hasError('required')) {
                <ats-lib-form-field-message
                  [message]="'l-required' | translate"
                ></ats-lib-form-field-message>
              }
              @if (control.touched && control.hasError('cellphone')) {
                <ats-lib-form-field-message
                  [message]="'l-invalid-cellphone-number' | translate"
                ></ats-lib-form-field-message>
              }
            </div>
          }

          @if (formGroup.get('linkedinUrl'); as control) {
            <div class="po-sm-12 field-mb">
              <po-url
                formControlName="linkedinUrl"
                [p-label]="'l-linkedin-url' | translate"
                [p-placeholder]="'l-write-linkedin-url' | translate"
                [atsLibFieldAriaLabel]="'l-linkedin-url' | translate"
                p-clean="true"
                data-cy="easy-apply-linkedin"
              ></po-url>

              @if (control.touched && (control.hasError('pattern') || control.hasError('url'))) {
                <ats-lib-form-field-message
                  [message]="'l-invalid-url' | translate"
                ></ats-lib-form-field-message>
              }
            </div>
          }

          @if (cpfRequired()) {
            @if (formGroup.get('cpf'); as control) {
              <div class="po-sm-12 field-mb">
                <p class="required-label">
                  {{ 'l-cpf' | translate }}
                  <span class="required-indicator" aria-hidden="true">*</span>
                </p>
                <po-input
                  formControlName="cpf"
                  p-mask="999.999.999-99"
                  p-mask-format-model="true"
                  [p-placeholder]="'l-applicant-cpf-placeholder' | translate"
                  [atsLibFieldAriaLabel]="'l-applicant-cpf-placeholder' | translate"
                  [p-required]="true | booleanToString"
                  data-cy="easy-apply-cpf"
                >
                </po-input>

                @if (control.touched && control.hasError('required')) {
                  <ats-lib-form-field-message
                    [message]="'l-required' | translate"
                  ></ats-lib-form-field-message>
                }
                @if (control.touched && control.hasError('cpf')) {
                  <ats-lib-form-field-message
                    [message]="'l-cpf-invalid' | translate"
                  ></ats-lib-form-field-message>
                }
              </div>
            }
          }

          @if (salaryRangeRequired()) {
            @if (formGroup.get('salaryRange'); as salaryRangeControl) {
              <div class="po-sm-12 field-mb">
                <div class="po-row po-p-0">
                  <p class="required-label po-mb-1 po-mr-1">
                    {{ 'l-salary-expectation' | translate }} {{ ' *' }}
                  </p>
                  <po-helper
                    [p-helper]="{
                      content: 'l-salary-required-helper' | translate,
                      type: 'info',
                    }"
                    p-size="small"
                  ></po-helper>
                </div>
                <div class="po-row po-p-0" formGroupName="salaryRange">
                  @if (formGroup.get('salaryRange.minimum'); as control) {
                    <div class="po-md-6 po-sm-12 po-pl-0 po-mb-sm-2 po-mb-mb-0 salary-range-field">
                      <po-decimal
                        [p-label]="'l-minimum-salary-range' | translate"
                        [p-placeholder]="'l-salary-placeholder' | translate"
                        [p-show-required]="salaryRangeRequired() && !salaryRangeFilled()"
                        (p-blur)="onSalaryRangeMinBlur()"
                        formControlName="minimum"
                        data-cy="salary-range-minimum"
                        [atsLibFieldAriaLabel]="'l-minimum-salary-range' | translate"
                      >
                      </po-decimal>
                      @if (
                        control.touched && control.invalid && control.errors?.salaryRangeValidator
                      ) {
                        <ats-lib-form-field-message
                          [message]="'l-job-opportunity-salary-min-validation' | translate"
                        ></ats-lib-form-field-message>
                      }
                    </div>
                  }
                  @if (formGroup.get('salaryRange.maximum'); as control) {
                    <div class="po-md-6 po-sm-12 po-pl-0 salary-range-field">
                      <po-decimal
                        [p-label]="'l-maximum-salary-range' | translate"
                        [p-placeholder]="'l-salary-placeholder' | translate"
                        [p-show-required]="salaryRangeRequired() && !salaryRangeFilled()"
                        formControlName="maximum"
                        data-cy="salary-range-maximum"
                        [atsLibFieldAriaLabel]="'l-maximum-salary-range' | translate"
                      >
                      </po-decimal>
                      @if (
                        control.touched && control.invalid && control.errors?.salaryRangeValidator
                      ) {
                        <ats-lib-form-field-message
                          [message]="'l-job-opportunity-salary-max-validation' | translate"
                        ></ats-lib-form-field-message>
                      }
                    </div>
                  }
                </div>
                @if (
                  salaryRangeControl.touched && salaryRangeControl.hasError('salaryRangeRequired')
                ) {
                  <ats-lib-form-field-message
                    class="salary-range-error-message"
                    [message]="'l-salary-range-required' | translate"
                    data-cy="salary-range-error-message"
                  ></ats-lib-form-field-message>
                }
              </div>
            }
          }

          @if (formGroup.get('attachmentFile'); as control) {
            <div class="po-sm-12 po-mb-4">
              <p class="po-mb-1 po-font-text-bold label-font-size required-label">
                {{ 'l-curriculum' | translate }}
                <span class="required-indicator" aria-hidden="true">*</span>
              </p>

              <ats-lib-button-upload
                [buttonText]="'l-attach-curriculum'"
                [fileQuantityLimit]="1"
                [fileSizeLimit]="FILE_SIZE_LIMIT"
                [acceptedExtensions]="['.pdf', '.doc', '.docx']"
                [filesList]="attachments()"
                [enableDraftMode]="true"
                [shouldDeleteFromList]="true"
                [fileClickable]="attachments().length > 0"
                (fileClicked)="onFileClicked()"
                (fileSelected)="onFileSelectChange($event)"
                (draftFilesChange)="onDraftFilesChanges($event)"
              ></ats-lib-button-upload>

              <div class="upload-info">
                <ats-lib-attachment-rules
                  [fileQuantity]="1"
                  [fileSizeLimit]="'2 MB'"
                  [totalLimit]="'2 MB'"
                  [allowedFormats]="'DOC, DOCX, PDF'"
                ></ats-lib-attachment-rules>
              </div>
            </div>
          }

          <div class="po-sm-12 terms-container">
            <ats-read-and-accept-terms-and-conditions-use
              [isLink]="true"
              (buttonClicked)="openTermsModal()"
              data-cy="easy-apply-terms"
            >
            </ats-read-and-accept-terms-and-conditions-use>
          </div>
        </div>
      </form>
    </section>

    @if (showFooter()) {
      <ats-footer (heightChanged)="onFooterHeightChange($event)">
        <div class="po-row">
          <div class="po-sm-12 po-p-0 footer-actions">
            <po-button
              class="cancel-btn"
              p-kind="secondary"
              [p-label]="'l-cancel' | translate"
              [atsLibFieldAriaLabel]="'l-cancel' | translate"
              (p-click)="onCancel()"
              data-cy="easy-apply-cancel"
            ></po-button>
            <po-button
              p-kind="primary"
              class="send-application-btn"
              [p-label]="'l-send-job-application' | translate"
              [atsLibFieldAriaLabel]="'l-send-job-application' | translate"
              (p-click)="onSubmit()"
              [p-disabled]="formGroup.invalid"
              [p-loading]="formGroup.errors?.pending || sendingApplication()"
              data-cy="easy-apply-submit"
            >
            </po-button>
          </div>
        </div>
      </ats-footer>
    }
  </div>
} @else {
  <ats-lib-spin-loader></ats-lib-spin-loader>
}
